import script from "./CharaConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./CharaConfig.vue?vue&type=script&setup=true&lang=js"

import "./CharaConfig.vue?vue&type=style&index=0&id=ea884a88&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea884a88"]])

export default __exports__